export const WEBSOCKET_STATES = {
  CONNECTING: 'CONNECTING',
  DISCONNECTED: 'DISCONNECTED',
  CONNECTED: 'CONNECTED',
}
export const subscriptionConstants = {
  WEBSOCKET_STATE: 'WEBSOCKET_STATE',
}
